// admin.sites.tsx — T094 (3/5)
// Route : /admin/sites

import { createFileRoute } from "@tanstack/react-router";

import { AdminSitesPage } from "@/presentation/pages/AdminSitesPage";

export const Route = createFileRoute("/admin/sites")({
  component: AdminSitesPage,
});
